import { PayoutType } from 'types';
import { Payout } from 'store/api/payout';

export const negativeSplitTypes = [
  PayoutType.NegativeTip,
  PayoutType.NegativeEarnings,
  PayoutType.NegativeAdjustment,
];

const isRefundItem = (item: Payout) =>
  item.notes?.includes('Refund earning for sale');

export const splitNegativeItems = (items: Payout[]) => {
  const negativeItems = items.filter((item) =>
    negativeSplitTypes.includes(item.type as PayoutType)
  );

  return {
    refundItems: negativeItems.filter(isRefundItem),
    chargebackItems: negativeItems.filter((item) => !isRefundItem(item)),
  };
};

export const sumItems = (items: Payout[]) =>
  items.reduce((acc, item) => acc + Number(item.amount || 0), 0);
